import { combineReducers } from 'redux';
import { WidgetType } from 'widgets/WidgetType';
import { createWidgetsReducer } from 'widgets/store/widgetsReducerFactory';
import { buildOrderLiquidityCapsuleConfigSlice } from './configslice';
import { VenueAnalysisCapsuleState } from 'widgets/venueAnalysis/capsules/store/VenueAnalysisCapsuleState';
import { VenueAnalysisCapsuleActionPayload } from 'widgets/venueAnalysis/capsules/store/actions';

const { reducer: configReducer } = buildOrderLiquidityCapsuleConfigSlice();

const orderLiquidityCapsuleWidgetReducer =
    combineReducers<VenueAnalysisCapsuleState>({
        config: configReducer,
    });

export const orderLiquidityCapsuleWidgetsReducer = createWidgetsReducer<
    VenueAnalysisCapsuleState,
    VenueAnalysisCapsuleActionPayload
>(WidgetType.ORDER_LIQUIDITY_CAPSULE, orderLiquidityCapsuleWidgetReducer);
